import { $ } from '../utils/Utils';

const SnackbarClose = (() => {
  const config = {
    get triggers() {
      return this.triggerCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current]);
    },
    triggerCN: ['js-snackbar-close'],
    component: $('.snackbar--secondary')[0],
  };

  const handleClick = () => {
    config.component.remove();
  };

  const build = () => {
    config.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => handleClick());
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();
export default SnackbarClose.init();
